import React from 'react'
import styled from 'styled-components'
import media from '../../utils/media'
import Title from './Title'
import ImageText from './ImageText'

const Container = styled.div`
  margin-bottom: ${props => props.marginBCont}px;
  .section-title {
    text-align: center;
    margin-bottom: 60px;
    ${media.mobileL`
      padding-top: 10px;
      margin-bottom: 30px;
    `}
  }
  ${media.mobileL`
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: calc(${props => props.marginBCont}px/2);
  `}
  ${media.laptopM`
    width: calc(100vw - 30px);
  `}
  ${media.laptop`
    width: 100%;
  `}
`

export default function ImageTextCont({ config }) {
  const { title, marginBCont, items } = config

  return (
    <Container marginBCont={marginBCont} className="col">
      <Title title={title} />
      {items.map(el => {
        return (
          <ImageText
            key={el.title}
            src={el.src}
            alt={el.alt}
            maxWidth={el.maxWidth}
            minWidth={el.minWidth}
            accent={el.accent}
            title={el.title}
            marginBText={el.marginBText}
            text={el.text}
            textList={el.textList}
            textTwo={el.textTwo}
            fontFamily={el.fontFamily}
            textSize={el.textSize}
          />
        )
      })}
    </Container>
  )
}
